import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PetsIcon from "@mui/icons-material/Pets";
import { useNavigate } from "react-router-dom";
import { login, setAuthToken } from "../../api/auth";


export default function Login({ onLogin }) {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    setFieldErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const nextErrors = {};

    if (!form.email.trim()) {
      nextErrors.email = "El correo es obligatorio.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      nextErrors.email = "Ingresa un correo valido.";
    }

    if (!form.password.trim()) {
      nextErrors.password = "La contrasena es obligatoria.";
    }

    setFieldErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!validate()) return;

    try {
      const response = await login(form);
      const token = response.token;
      localStorage.setItem("token", token);
      localStorage.setItem("token_time", Date.now());
      setAuthToken(token);
      onLogin();
      navigate("/pets", { replace: true });
    } catch (err) {
      setError("Credenciales incorrectas o error de servidor");
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      
    >
      <Box
        sx={{
          textAlign: "center",
          px: { xs: 2, sm: 4, md: 6 },
          py: { xs: 4, sm: 6 },
          borderRadius: "24px",
          position: "relative",
          overflow: "hidden",
          backgroundColor: "#fcffff",
          border: "3px solid #e0f2e9",
          boxShadow: "0 8px 32px rgba(27, 141, 75, 0.08)",
          maxWidth: 500,
          width: "90%",

          "&:before": {
            content: '""',
            position: "absolute",
            top: -50,
            right: -50,
            width: "200px",
            height: "200px",
            backgroundImage: "url('/assets/logo.webp')",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            opacity: 0.08,
            transform: "rotate(15deg)",
          },
        }}
      >
        <Box position="relative" zIndex={1}>
          <Typography
            variant="h2"
            component="h1"
            gutterBottom
            sx={{
              fontSize: {
                xs: "1.8rem",
                sm: "2.2rem",
                md: "2.5rem",
              },
              fontFamily: "'Comic Relief', cursive",
              fontWeight: 700,
              color: "#1B8D4B",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            <PetsIcon sx={{ color: "#FFA500", fontSize: "inherit" }} />
            Iniciar Sesión
          </Typography>

          <Typography
            variant="h6"
            component="p"
            sx={{
              maxWidth: "400px",
              mx: "auto",
              mb: 4,
              fontFamily: "'Alexandria', sans-serif",
              fontWeight: 400,
              color: "#555",
              fontSize: {
                xs: "0.9rem",
                sm: "1rem",
              },
            }}
          >
            Ingresa tus credenciales para acceder al sistema
          </Typography>

          {error && (
            <Alert
              severity="error"
              sx={{
                mb: 3,
                fontFamily: "'Alexandria', sans-serif",
              }}
            >
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Correo electrónico"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              margin="normal"
              error={Boolean(fieldErrors.email)}
              helperText={fieldErrors.email}
              InputProps={{
                sx: {
                  fontFamily: "'Alexandria', sans-serif",
                },
              }}
              InputLabelProps={{
                sx: {
                  fontFamily: "'Alexandria', sans-serif",
                },
              }}
            />
            <TextField
              fullWidth
              label="Contraseña"
              name="password"
              type={showPassword ? "text" : "password"}
              value={form.password}
              onChange={handleChange}
              margin="normal"
              error={Boolean(fieldErrors.password)}
              helperText={fieldErrors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
                sx: {
                  fontFamily: "'Alexandria', sans-serif",
                },
              }}
              InputLabelProps={{
                sx: {
                  fontFamily: "'Alexandria', sans-serif",
                },
              }}
            />
            <Button
              fullWidth
              variant="contained"
              type="submit"
              sx={{
                mt: 3,
                py: 1.5,
                backgroundColor: "#1B8D4B",
                borderRadius: "50px",
                fontFamily: "'Alexandria', sans-serif",
                fontWeight: 600,
                fontSize: "1rem",
                "&:hover": {
                  backgroundColor: "#14703B",
                },
              }}
            >
              Iniciar sesión
            </Button>
          </form>
        </Box>
      </Box>
    </Box>
  );
}
